// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const socialLinksUrls = [
    {
        href: "https://www.facebook.com/Atlassian",
        title: "Atlassian on Facebook",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/facebook-badge.svg"
    },
    {
        href: "https://twitter.com/atlassian",
        title: "Follow us on Twitter",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/twitter.svg"
    },
    {
        href: "https://www.linkedin.com/company/atlassian",
        title: "Atlassian on LinkedIn",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/linked-in.svg"
    },
    {
        href: "https://www.youtube.com/user/GoAtlassian",
        title: "Atlassian on YouTube",
        socialImagePath:
            "https://wac-cdn.atlassian.com/assets/img/icons/social-icons/youtube-round-gray-adg.svg"
    }
];

const socialLinksUlStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: unset;

    ${UNSAFE_media.below.sm} {
        gap: 13px;
    }
    ${media.above.sm} {
        gap: 5px;
    }
`;

const socialLinksLiStyle = css`
    list-style-type: none;

    ${UNSAFE_media.below.md} {
        height: ${token("space.300")};
        width: ${token("space.300")};
    }
    ${media.above.md} {
        height: ${token("space.400")};
        width: ${token("space.400")};
    }
`;

const socialAnchorStyle = (socialLinksUrlImage: string) => {
    return css`
        background: url(${socialLinksUrlImage}) no-repeat scroll center center;
        background-size: auto;
        background-size: 100%;

        color: #42526e;
        font-size: 0.875rem;
        line-height: 1.125;
        text-decoration: none;
        display: block;
        text-indent: -99999px;
        width: 100%;
        height: 100%;
    `;
};

export interface SocialLinksProps {
    className?: string;
}

export const SocialLinks = ({ className }: SocialLinksProps) => {
    return (
        <div
            className={className}
            css={css`
                display: inline-flex;
            `}
        >
            <ul css={socialLinksUlStyle}>
                {socialLinksUrls.map((socialLinkUrl) => (
                    <li css={socialLinksLiStyle} key={socialLinkUrl.title}>
                        <a
                            css={socialAnchorStyle(
                                socialLinkUrl.socialImagePath
                            )}
                            href={socialLinkUrl.href}
                            title={socialLinkUrl.title}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
